import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "../../components/form-controls/Button";
import Input from "../../components/form-controls/Input";
import Select from "../../components/form-controls/Select";
import TextArea from "../../components/form-controls/TextArea";
import InvalidFeedback from "../../components/InvalidFeedback";
import Tags from "../../components/Tags";
import { upload } from "@testing-library/user-event/dist/upload";
import { BotService } from "../../services/BotService";
import { AlertService } from "../../services/Alert";
import { useTranslation } from "react-i18next";
function FormDefaultNodePage({ node, onDelete, chatbotInfo }) {

    const { t } = useTranslation();

    const defaultValues = {
        _id: '',
        is_root: false,
        name: '',
        parent_nodes: [],
        keywords: [],
        type: 'DEFAULT',
        default: { 
            type: '',
            text: { es: '' },
            image: { 
                es: {
                    link: '',
                } 
            },
            video: { 
                es: {
                    link: '',
                } 
            },
            audio: { 
                es: {
                    link: '',
                } 
            },
            document: { 
                es: {
                    link: '',
                } 
            },
            file: ''
        }
    }
    
    const typeMessageList = [
        {
            value: '',
            text: t("platform.chatbot.default-node.select"),
            disabled: true,
        },
        {
            value: 'TEXT',
            text: t("platform.chatbot.default-node.text"),
        },
        {
            value: 'IMAGE',
            text: t("platform.chatbot.default-node.image"),
        },
        // {
        //     value: 'VIDEO',
        //     text: 'Video',
        // },
        // {
        //     value: 'AUDIO',
        //     text: 'Audio',
        // },
        // {
        //     value: 'DOCUMENT',
        //     text: 'Documento',
        // },
    ]
    

    const { control, register, watch, getValues, setValue, reset, handleSubmit, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const typeMessage = watch('default.type')

    const uploadFile = async(file) => {
        try {
            const data = new FormData();
            data.append('file', file)
            
            const response = await BotService.uploadFile(data);

            return response.data.url
        } catch (error) {
            console.error(error)

            AlertService.error('¡Error!', 'No se pudo guardar el archivo, intenta más tarde.')
            
            throw new Error(error)
        }
    }

    const submit = async (data: any) => {
        
        const { default: { type }, ...params } = data;

        let defaultType = type.toLowerCase();
        let defaultTypeData = data.default[defaultType]

        if( type !== 'TEXT' && data.default.file[0]) {
            defaultTypeData.es.link = data = await uploadFile(data.default.file[0])
        }

        params.default = {
            type,
            [defaultType]: defaultTypeData
        }

        params.position = node.position;

        await node.data.handleSaveNode({ nodeID: node.id, data: params, chatbotInfo })

        setValue('default.file', '')
    }

    useEffect(() => {
      reset(Object.assign(defaultValues, node.data ))
    }, [node.data])
    

    return (
        <>
            <div className="card-header bg-soft-info-alternative">
                <h3 className="card-header-title">{t("platform.chatbot.default-node.config-title")}</h3>
                <p className="m-0"><small className="text-muted">{t("platform.chatbot.default-node.default")}</small></p>
                { getValues('_id') && <p className="m-0"><small className="text-muted">Nodo id: {getValues('_id')}</small></p> }
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="mb-3">
                        <Input label={t("platform.chatbot.default-node.name")} errors={errors.name} {...register('name', { required: true })} />
                    </div>

                    {/* <div className="mb-3">
                        <label className="form-label" >Palabras clave <span className="form-label-secondary">(Escriba algo y pulse enter)</span></label>
                        <Controller
                            control={control}
                            name='keywords'
                            render={({
                                field: { onChange, value  },
                                fieldState: { error },
                            }) => {
                                return (
                                    <Tags
                                        isInvalid={!!error}
                                        onChange={(values: any) => onChange(values)}
                                        initialValue={value.map( v => ({label: v, value: v}))}
                                    />                            
                                )
                            }}
                        />
                        <InvalidFeedback error={errors.keywords} />
                    </div> */}

                    <div className="mb-3">
                        <Select label={t("platform.chatbot.default-node.type-message")} data={typeMessageList} errors={errors.default?.type} {...register('default.type', { required: true })} />
                    </div>

                    {
                        typeMessage === 'TEXT' && (
                            <div className="mb-3">
                                <TextArea
                                    label={t("platform.chatbot.default-node.message")}
                                    errors={errors.default?.text?.es}
                                    value={watch('default.text.es').length}
                                    counter={1024}
                                    {...register('default.text.es', { required: true, maxLength: { value: 1024, message: '1024' } })} />
                            </div>
                        )
                    }
                    {
                        typeMessage === 'IMAGE' && (
                            <>
                                <div className="mb-3">
                                    {getValues('default.image.es.link') && <img src={getValues('default.image.es.link')} className='img-fluid' />}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label" >{  getValues('_id')? 'Cambiar imagen': t("platform.chatbot.default-node.image-label")}</label>
                                    <input type="file" className="form-control" {...register('default.file', { required: !getValues('_id') } )}/>
                                    <InvalidFeedback error={errors.default?.file} />
                                </div>
                            </>
                        )
                    }
                    <div className="d-grid gap-2 my-3 ">
                        <Button type="submit" className="btn btn-primary" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                    </div>


                    {
                        getValues('_id') && (
                            <div className="d-grid gap-2 my-3 ">
                                <Button type="submit" className="btn btn-ghost-danger"  onClick={() => onDelete(getValues('_id')) }>{t("platform.chatbot.delete-node")}</Button>
                            </div>
                        )
                    }
                    
                </form>


            </div>
        </>
    )
}
export default FormDefaultNodePage